var _defs, _path, _path2, _polygon, _polygon2, _rect, _polygon3, _path3, _polygon4, _path4, _path5, _path6, _path7, _polygon5, _rect2, _path8, _path9, _rect3, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 161.86,
    viewBox: "0 0 500 161.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 82.32,
    y1: 285.72,
    x2: 20.87,
    y2: 224.26,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 327.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 126.39,
    y1: 244.37,
    x2: 37.79,
    y2: 244.37,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 327.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 93.41,
    y1: 235.97,
    x2: 10.07,
    y2: 152.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 327.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.22,
    y1: 316.97,
    x2: 66.43,
    y2: 279.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 327.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.2,161.86H28.39a52.35,52.35,0,0,1-8-.84,46.68,46.68,0,0,1-7.2-2.12,30,30,0,0,1-5.94-4.24A19,19,0,0,1,3,148.73a20.07,20.07,0,0,1-2.12-7.2A46.17,46.17,0,0,1,0,133.9V28.39a46.23,46.23,0,0,1,.85-8A45.59,45.59,0,0,1,3,13.14,30.37,30.37,0,0,1,7.2,7.2,19.11,19.11,0,0,1,13.14,3c2.11-1.28,4.66-1.7,7.2-2.12A46.23,46.23,0,0,1,28.39,0H471.61a57.07,57.07,0,0,1,8.05.85A45.59,45.59,0,0,1,486.86,3,23.46,23.46,0,0,1,497,13.14a20.56,20.56,0,0,1,2.12,6.78,51,51,0,0,1,.85,8v105.5a57,57,0,0,1-.85,8.06,45.59,45.59,0,0,1-2.12,7.2,30,30,0,0,1-4.23,5.93,19.14,19.14,0,0,1-5.94,4.24,14.27,14.27,0,0,1-7.2,2.12,47.25,47.25,0,0,1-8.05.84H32.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.84,54.61a11.06,11.06,0,0,0,8.33-3.35,11.14,11.14,0,0,0,2.68-9.32l-.06-.3H158.47V45h7.94a6.36,6.36,0,0,1-1.69,3.82,8.39,8.39,0,0,1-11.63,0,8.13,8.13,0,0,1-2.42-6.08,8.13,8.13,0,0,1,8.17-8.41,7,7,0,0,1,5.73,2.48l.26.3,2.45-2.45-.21-.26a9.55,9.55,0,0,0-3.58-2.55,11.72,11.72,0,0,0-4.65-.95,11.68,11.68,0,0,0-11.78,11.84,11.68,11.68,0,0,0,11.78,11.84Z",
    fill: "#000"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "186.88 50.69 176.88 50.69 176.88 44.46 185.9 44.46 185.9 41.09 176.88 41.09 176.88 34.85 186.88 34.85 186.88 31.42 173.32 31.42 173.32 54.12 186.88 54.12 186.88 50.69",
    fill: "#000"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "198.79 54.12 198.79 34.85 204.93 34.85 204.93 31.42 189.09 31.42 189.09 34.85 195.23 34.85 195.23 54.12 198.79 54.12",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215.12,
    y: 31.42,
    width: 3.55,
    height: 22.7,
    fill: "#000"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.2 54.12 231.2 34.85 237.33 34.85 237.33 31.42 221.5 31.42 221.5 34.85 227.64 34.85 227.64 54.12 231.2 54.12",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.49,54.61a11.16,11.16,0,0,0,8.32-3.44,11.62,11.62,0,0,0,3.34-8.4,11.64,11.64,0,0,0-3.36-8.39,11.73,11.73,0,0,0-16.61,0,11.62,11.62,0,0,0-3.34,8.4,11.6,11.6,0,0,0,3.34,8.4A11.12,11.12,0,0,0,257.49,54.61Zm-5.71-17.89a8.09,8.09,0,0,1,11.42,0,8.3,8.3,0,0,1,2.34,6.05,8.28,8.28,0,0,1-2.34,6,8.09,8.09,0,0,1-11.42,0,8.31,8.31,0,0,1-2.33-6A8.33,8.33,0,0,1,251.78,36.72Z",
    fill: "#000"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.93 40.06 275.85 36.98 286.43 53.95 286.54 54.12 290.05 54.12 290.05 31.42 286.5 31.42 286.5 44.66 286.58 47.74 276.39 31.42 272.38 31.42 272.38 54.12 275.93 54.12 275.93 40.06",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5,85.81a15.57,15.57,0,1,0,15.64,15.57A15.34,15.34,0,0,0,245.5,85.81Zm0,25c-4.72,0-8.79-3.89-8.79-9.44s4.07-9.44,8.79-9.44,8.79,3.84,8.79,9.44S250.22,110.82,245.5,110.82Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.4,85.81A15.57,15.57,0,1,0,227,101.38,15.34,15.34,0,0,0,211.4,85.81Zm0,25c-4.72,0-8.79-3.89-8.79-9.44s4.07-9.44,8.79-9.44,8.79,3.84,8.79,9.44S216.12,110.82,211.4,110.82Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.37,89.29h-.24a10.78,10.78,0,0,0-8.2-3.48c-7.79,0-14.93,6.84-14.93,15.63S271.14,117,278.93,117a10.63,10.63,0,0,0,8.2-3.53h.24v2.24c0,6-3.19,9.14-8.32,9.14a8.62,8.62,0,0,1-7.85-5.54l-6,2.47a14.86,14.86,0,0,0,13.81,9.21c8,0,14.81-4.72,14.81-16.23v-28h-6.49Zm-7.85,21.53c-4.72,0-8.67-3.95-8.67-9.38s3.95-9.5,8.67-9.5,8.32,4,8.32,9.5S284.18,110.82,279.52,110.82Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.21,85.72c-4.95,0-10.07,2.18-12.19,7l6.06,2.53c1.3-2.53,3.71-3.36,6.24-3.36,3.54,0,7.13,2.13,7.19,5.89v.48a15.1,15.1,0,0,0-7.13-1.77c-6.53,0-13.19,3.59-13.19,10.31,0,6.12,5.36,10.07,11.37,10.07a9.62,9.62,0,0,0,8.71-4.48h.24v3.53h6.6V98.38C425.11,90.26,419,85.72,411.21,85.72Zm-.83,25.09c-2.24,0-5.36-1.12-5.36-3.89,0-3.53,3.89-4.89,7.25-4.89a12.11,12.11,0,0,1,6.24,1.54A8.28,8.28,0,0,1,410.38,110.81Z",
    fill: "#000"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.13 86.72 441.3 106.57 441.07 106.57 432.94 86.72 425.58 86.72 437.77 114.46 430.82 129.89 437.94 129.89 456.73 86.72 449.13 86.72",
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 298.58,
    y: 70.23,
    width: 6.84,
    height: 45.78,
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M336.75,95.72c-1.3-3.48-5.25-9.91-13.34-9.91s-14.69,6.31-14.69,15.57A15.24,15.24,0,0,0,324.18,117a15.48,15.48,0,0,0,13-6.9l-5.31-3.54a8.89,8.89,0,0,1-7.67,4.31,7.91,7.91,0,0,1-7.55-4.72l20.82-8.61Zm-21.24,5.19a8.54,8.54,0,0,1,8.14-9.09c2.71,0,5,1.36,5.78,3.31Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.8,70.23H352.43V116h6.83V98.67h9.54c7.58,0,15-5.49,15-14.22S376.38,70.23,368.8,70.23ZM369,92.3h-9.72V76.6H369a7.85,7.85,0,1,1,0,15.7Z",
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 387.59,
    y: 70.23,
    width: 6.83,
    height: 45.78,
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.83,90.58v6.61h15.81c-.47,3.72-1.71,6.43-3.6,8.32a16.19,16.19,0,0,1-12.21,4.84,17.58,17.58,0,0,1,0-35.16,16.83,16.83,0,0,1,11.92,4.72l4.66-4.67a23.09,23.09,0,0,0-16.58-6.66c-13.33,0-24.54,10.85-24.54,24.19S157.5,117,170.83,117c7.2,0,12.62-2.35,16.87-6.78s5.73-10.5,5.73-15.46a21.23,21.23,0,0,0-.36-4.13Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.71,37.26A7.33,7.33,0,0,0,39,42.41v81a7.33,7.33,0,0,0,1.7,5.15l.27.26L86.35,83.43V82.36L41,37Z",
    fill: "url(#a)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.47,98.56,86.35,83.43V82.36l15.12-15.12.34.19,17.92,10.18c5.12,2.91,5.12,7.67,0,10.58L101.81,98.37Z",
    fill: "url(#b)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.81,98.37,86.35,82.9,40.71,128.54c1.69,1.78,4.47,2,7.61.22l53.49-30.39",
    fill: "url(#c)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.81,67.43,48.32,37c-3.14-1.79-5.92-1.57-7.61.22L86.35,82.9Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,98l-53.15,30.2c-3,1.69-5.63,1.57-7.34,0h0l-.27.27h0l.27.26h0c1.71,1.54,4.37,1.65,7.34,0l53.49-30.39Z",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.71,128a7.28,7.28,0,0,1-1.7-5.14v.53a7.33,7.33,0,0,0,1.7,5.15l.27-.27Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73,87.65,101.47,98l.34.34,17.92-10.18c2.56-1.46,3.84-3.37,3.84-5.29h0C123.35,84.63,122.05,86.33,119.73,87.65Z",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.32,37.57l71.41,40.58c2.32,1.32,3.62,3,3.84,4.75h0c0-1.92-1.28-3.83-3.84-5.29L48.32,37C43.2,34.13,39,36.55,39,42.41v.53C39,37.08,43.2,34.66,48.32,37.57Z",
    fill: "#000",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidDownloadWhite);
export default __webpack_public_path__ + "static/media/android-download-white.4c85ffb0c9197a749abf17fdf486dd32.svg";
export { ForwardRef as ReactComponent };